const AccScaleData = [
    {
        dataheading: "Accounts Payable",
        description:"Amount that you are yet to pay to your vendor",
        bills:"Total unpaid bills : ₹ 45,380.00",
        openbill:"₹ 45,380.00",
        overduebill:"₹ 37,380.00",
        details:"View Details"
    },
    {
        dataheading: "Accounts Receivable",
        description:"Amount that you are yet to receive from your customers",
        bills:"Total unpaid bills : ₹ 45,380.00",
        openbill:"₹ 45,380.00",
        overduebill:"₹ 37,380.00",
        details:"View Details"
    }
]

export  default AccScaleData 
